import { useAuth } from '../context/AuthContext'

export const WithPermission = (props) => {
  const { rolesRequired, children } = props;
  const { userRole } = useAuth();

  // Convert single role to array for consistent handling
  const allowedRoles = Array.isArray(rolesRequired) 
      ? rolesRequired 
      : [rolesRequired];

  return (
      <>
          {allowedRoles.includes(userRole) && children}
      </>
  )
}
